import React from 'react';
import { Box, Button, BUTTON_TYPES, BUTTON_SIZES } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import { useFormContext } from 'react-hook-form';
import { FieldConfig } from './VALoanCalculator.utils.js';
import { handleFieldClickEvent } from './VALoanCalculator.Clickstream.js';

var VALoanCalculatorFullReportButton = function VALoanCalculatorFullReportButton() {
  var form = useFormContext();
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      top: '$spacing.xs',
      right: '$spacing.md',
      'z-index': '10',
      '@media $sm_lte': {
        display: 'none'
      }
    }
  }, /*#__PURE__*/React.createElement(Button, {
    buttonType: BUTTON_TYPES.secondary,
    type: "button",
    size: BUTTON_SIZES.sm,
    onClick: yieldCallback(function () {
      var values = form.getValues();
      var url = new URL('https://www.zillow.com/mortgage/calculator/payment/advanced-report/');
      url.searchParams.set('homePrice', values[FieldConfig.homePrice.name]);
      url.searchParams.set('downPayment', values[FieldConfig.downPayment.name]);
      url.searchParams.set('downPaymentPercent', values[FieldConfig.downPaymentPercent.name]);
      url.searchParams.set('rate', values[FieldConfig.interestRate.name]);
      url.searchParams.set('term', values[FieldConfig.loanProgram.name]);
      url.searchParams.set('monthlyHOA', values[FieldConfig.hoa.name]);
      url.searchParams.set('includeTaxesInsurance', values[FieldConfig.includeTaxesInsurance.name]);
      url.searchParams.set('propertyTaxRateAnnualAmount', values[FieldConfig.taxRate.name]);
      url.searchParams.set('propertyTaxRate', values[FieldConfig.taxRatePercent.name]);
      url.searchParams.set('annualHomeownersInsurance', values[FieldConfig.homeInsurance.name]);
      url.searchParams.set('zipCode', values[FieldConfig.zipCode.name]);
      url.searchParams.set('includePMI', values[false]);
      // This happens onClick which is only in window
      // eslint-disable-next-line no-undef
      window.open(url.toString(), '_blank');
      handleFieldClickEvent('Full report', 'button');
    })
  }, "Full report"));
};
var VALoanCalculatorFullReportButton$1 = VALoanCalculatorFullReportButton;

export { VALoanCalculatorFullReportButton$1 as default };
